module.exports = __webpack_public_path__ + "img/image62.2d91689a.png";